import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-list-blog',
  templateUrl: './page-list-blog.component.html',
  styleUrls: ['./page-list-blog.component.scss']
})
export class PageListBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
